var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mobile)?_c('router-link',{class:{ arrow: true, 'hidden-sm-and-up': true, selected: _vm.selected },style:({
    backgroundImage:
      (_vm.selected ? _vm.linearGradient : _vm.overlay) +
      _vm.categoryBackgroundImage,
  }),attrs:{"to":`/products/${_vm.productCategory.slug}#products`},nativeOn:{"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[_vm._v("\n  "+_vm._s(_vm.productCategory.title)+"\n  "+_vm._s(_vm.selected ? 'ACTIVE' : 'NOT')+"\n")]):_c('router-link',{class:{ arrow: true, 'hidden-xs-only': true, selected: _vm.selected },style:({
    backgroundImage:
      (_vm.selected ? _vm.linearGradient : _vm.overlay) +
      _vm.categoryBackgroundImage,
  }),attrs:{"to":`/products/${_vm.productCategory.slug}`},nativeOn:{"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[_vm._v("\n  "+_vm._s(_vm.productCategory.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }